"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapBastResponseToBillingHistoryLegacy = exports.isActiveBillingPeriod = void 0;
var date_fns_1 = require("date-fns");
var get_billing_history_1 = require("./get-billing-history");
var isLatestBillingPeriodActive = function (billingPeriod, index) { return (index === 0 ? (0, exports.isActiveBillingPeriod)(billingPeriod) : false); };
var isActiveBillingPeriod = function (_a) {
    var start = _a.start, end = _a.end, isStatementAvailable = _a.isStatementAvailable;
    return (0, date_fns_1.isWithinInterval)((0, date_fns_1.format)(new Date().toUTCString(), 'yyyy-MM-dd'), {
        start: start,
        end: end,
    }) && !isStatementAvailable;
};
exports.isActiveBillingPeriod = isActiveBillingPeriod;
var migratedDescription = 'Migrated Balance';
var isOnlyMigrationTransaction = function (billingPeriod) {
    if (billingPeriod.transactions.length === 1 &&
        billingPeriod.transactions[0].description === migratedDescription) {
        return true;
    }
    return false;
};
var hasEmptyTransactions = function (billingPeriod) {
    var _a;
    // empty if there are no charges, no payments, no transactions
    return billingPeriod.totalCharge.grossCharge.pounds === '0' &&
        billingPeriod.payments.length === 0 &&
        billingPeriod.transactions.length === 0 &&
        ((_a = billingPeriod.electricityCharges) === null || _a === void 0 ? void 0 : _a.length) == 0;
};
var hasMigrationTransactions = function (billingPeriod) {
    return Boolean(billingPeriod.transactions.length &&
        billingPeriod.transactions.some(function (transaction) { return transaction.description === migratedDescription; }));
};
//Mapping BAST data to Legacy and OrionLegacy shape called BillingHistoryLegacy
var mapBastResponseToBillingHistoryLegacy = function (billablePeriods, migratedStatements) {
    var history = (0, get_billing_history_1.getBillingHistory)(billablePeriods, migratedStatements);
    var _a = __read(history.orionBillingHistory.reduce(function (_a, billingPeriod, index) {
        var _b = __read(_a, 2), migrated = _b[0], standard = _b[1];
        if (hasMigrationTransactions(billingPeriod)) {
            if (isOnlyMigrationTransaction(billingPeriod)) {
                return [__spreadArray(__spreadArray([], __read(migrated), false), [billingPeriod], false), standard];
            }
            return [
                __spreadArray(__spreadArray([], __read(migrated), false), [billingPeriod], false),
                __spreadArray(__spreadArray([], __read(standard), false), [billingPeriod], false),
            ];
        }
        // filters
        if (hasEmptyTransactions(billingPeriod) ||
            isOnlyMigrationTransaction(billingPeriod) ||
            isLatestBillingPeriodActive(billingPeriod, index)) {
            return [migrated, standard];
        }
        return [migrated, __spreadArray(__spreadArray([], __read(standard), false), [billingPeriod], false)];
    }, 
    // TS defaults to never[] which then breaks the typing ???
    [[], []]), 2), migrated = _a[0], standard = _a[1];
    history = __assign(__assign({}, history), { migrationNotices: migrated, orionBillingHistory: standard });
    return history;
};
exports.mapBastResponseToBillingHistoryLegacy = mapBastResponseToBillingHistoryLegacy;
